import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "contents-list-icon" }
const _hoisted_3 = { class: "contents-list-icon-main" }
const _hoisted_4 = {
  class: "contents-questions-disease",
  id: "survey_classification_code"
}
const _hoisted_5 = { class: "contents-questions-disease-title" }
const _hoisted_6 = { class: "contents-questions-disease-name" }
const _hoisted_7 = { class: "contents-questions-introduction" }
const _hoisted_8 = { class: "contents-questions-warning-text" }
const _hoisted_9 = {
  class: "contents-questions-byuse",
  id: "survey_classification"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "question-title" }
const _hoisted_12 = {
  key: 0,
  class: "contents-question-one-time-only",
  src: "/server/necs/images/one-time_badge.png"
}
const _hoisted_13 = {
  key: 1,
  class: "contents-question-answered",
  src: "/server/necs/images/done_thankyou_badge.png"
}
const _hoisted_14 = { class: "contents-profile-button" }

import { ref, onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { processing, processend } from "@/utils/view";
import { HealthCare } from "@/models/healthCare/healthCare";
import { SurveyForm } from "@/models/healthCare/surveyForm";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";

import CommonMessage from "@/views/base/CommonMessage.vue";

// ---- Types -------------------------------------------------
type Surveys = {
  code: string;
  classificationCode: string;
  title: string;
  answered: boolean;
};

type DiseaseDetail = {
  code: string;
  name: string;
};

// ---- Variable ----------------------------------------------
// セッションエラーチェック
const componentId = "healthcaredata00-02";
const activeMenu = "health-care";

export default /*@__PURE__*/_defineComponent({
  __name: 'Survey',
  setup(__props) {

let sessionErr = ref(false);
let errorDialog = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// ---- Constant ----------------------------------------------
const route = useRoute();
const router = useRouter();
const diseaseDetail = ref<DiseaseDetail>({ code: "", name: "" });
const surveys = ref<Surveys[]>([]);
const diseaseCode = ref(route.params.diseaseCode as string);
const healthCare = new HealthCare();
const surveyForm = new SurveyForm();

// ----- Function -----------------------------------------------
// 疾患詳細取得
const fetchDiseaseDetail = async (diseaseCode: string) => {
  await healthCare
    .getDiseaseDetail(diseaseCode)
    .then(([model, _response, err]) => {
      if (err) {
        const status = err.error.response.status;
        const decodedMessage = decodeURIComponent(
          err.error?.response?.data?.message
        );
        // セッションエラー
        if (status === 408) sessionErr.value = true;
        errorDialog.open(decodedMessage);
        return;
      } else {
        diseaseDetail.value = model.attributes?.result || null;
      }
    });
};

// アンケート一覧取得
const fetchSurveys = async (diseaseCode: string) => {
  await surveyForm.getSurveys(diseaseCode).then(([model, _response, err]) => {
    if (err) {
      const status = err.error.response.status;
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      // セッションエラー
      if (status === 408) sessionErr.value = true;
      errorDialog.open(decodedMessage);
      return;
    } else {
      surveys.value = model.attributes?.result || [];
    }
  });
};

//設問画面遷移
const goToSurveyForm = (surveyCode: string) => {
  router.push({
    name: "health-care/survey/form",
    params: { surveyCode: surveyCode },
  });
};

//戻るボタン処理
const goBack = () => {
  router.push({ name: "health-care" });
};

// ---- Vue lifeCycle ----------------------------------------------
onMounted(async () => {
  await fetchDiseaseDetail(diseaseCode.value);
  await fetchSurveys(diseaseCode.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Header, { activeMenu: activeMenu }),
        _createElementVNode("main", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("healthcare_msg_title")), 1),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "contents-list-icon-tri" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("healthcare_msg_selected_disease")), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(diseaseDetail.value.name), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("healthcare_msg_questions_introduction")), 1),
            _createElementVNode("p", _hoisted_8, [
              _cache[1] || (_cache[1] = _createElementVNode("img", {
                src: "/server/necs/images/info_wght400.png",
                alt: "info-icon"
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("healthcare_msg_warning_label")), 1)
            ])
          ]),
          _createElementVNode("ul", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(surveys.value, (survey) => {
              return (_openBlock(), _createElementBlock("li", {
                key: survey.code,
                class: "contents-question-button",
                onClick: ($event: any) => (goToSurveyForm(survey.code))
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("img", {
                  class: "contents-question-background",
                  src: "/server/necs/images/bnr-m-575_or.png",
                  alt: "survey-image"
                }, null, -1)),
                _createElementVNode("span", _hoisted_11, _toDisplayString(survey.title) + _toDisplayString(_ctx.$t("healthcare_msg_list_here")), 1),
                (survey.classificationCode === '01')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                  : _createCommentVNode("", true),
                (survey.answered)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_10))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              id: "edit-button",
              onClick: goBack
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("healthcare_button_go_back_diseases")), 1)
            ])
          ])
        ]),
        _createVNode(Footer, { "scroll-target": componentId })
      ])
    ]),
    (_unref(errorDialog).show)
      ? (_openBlock(), _createBlock(CommonMessage, _mergeProps({ key: 0 }, _unref(errorDialog), {
          onOk: _unref(errorDialog).close,
          onCancel: _unref(errorDialog).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})